import apiClient from '../../../lib/client';

export const authoritiesAPI = {
  // Public
  list: (params = {}) => apiClient.get('/authorities', { params }).then((r) => r.data),
  stats: () => apiClient.get('/authorities/stats').then((r) => r.data),
  get: (id) => apiClient.get(`/authorities/${id}`).then((r) => r.data),
  submitUrl: (id, url, notes) =>
    apiClient.post(`/authorities/${id}/submissions`, { url, notes }).then((r) => r.data),

  // Admin
  listSubmissions: (params = {}) =>
    apiClient.get('/authorities/submissions', { params }).then((r) => r.data),
  reviewSubmission: (id, action, notes) =>
    apiClient.patch(`/authorities/submissions/${id}`, { action, notes }).then((r) => r.data),
  update: (id, data) => apiClient.patch(`/authorities/${id}`, data).then((r) => r.data),
  discoverWebsite: (id) =>
    apiClient
      .post(`/authorities/${id}/discover-website`, {}, { timeout: 30_000 })
      .then((r) => r.data),
  triggerCheck: (id, signal) =>
    apiClient.post(`/authorities/${id}/check`, {}, { signal }).then((r) => r.data),
  runScraper: (id, signal) =>
    apiClient.post(`/authorities/${id}/scrape`, {}, { signal }).then((r) => r.data),
  listChecks: (params = {}) => apiClient.get('/authorities/checks', { params }).then((r) => r.data),

  // Sources (typed URLs)
  saveSource: (id, kind, url) =>
    apiClient.put(`/authorities/${id}/sources/${kind}`, { url }).then((r) => r.data),

  // Voter preparedness
  savePreparedness: (id, key, status, details, sourceUrl) =>
    apiClient
      .patch(`/authorities/${id}/preparedness`, { key, status, details, sourceUrl })
      .then((r) => r.data),
};
